var _circle, _circle2, _circle3, _path, _path2, _line;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgEditingListUl(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 8,
    r: 2,
    transform: "rotate(90 6 8)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 16,
    r: 2,
    transform: "rotate(90 6 16)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 6,
    cy: 24,
    r: 2,
    transform: "rotate(90 6 24)",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28 24L12 24",
    stroke: "currentColor",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28 16L12 16",
    stroke: "currentColor",
    strokeWidth: 2
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 28,
    y1: 8,
    x2: 12,
    y2: 8,
    stroke: "currentColor",
    strokeWidth: 2
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditingListUl);
export default __webpack_public_path__ + "static/media/EditingListUL.06d169f7.svg";
export { ForwardRef as ReactComponent };